// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"8dd2bf53","488":"b6ec6f7a","783":"c4b4ee4f"}[chunkId] + ".chunk.js";
};